import DraftInquiryRoute from '@/components/draftInquiryRoute';

export default DraftInquiryRoute;
